<template>
  <button
    v-ripple
    v-if="isValidProduct(product)"
    :class="$product.product"
    @click="$emit('click')">
    <div :class="$product.image">
      <v-img
        :src="imageUrl"
        contain
        aspect-ratio="1"/>
    </div>
    <p :class="$product.name">
      {{ name }}
    </p>
    <p v-if="product.price"
       :class="$product.price">
      ${{ getFormattedProductPrice(product.price) }}
    </p>
    <p v-if="product.description"
       :class="$product.description">
      {{ product.description }}
    </p>
  </button>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import helpers from '@/lib/helpers';

@Component({
  props: {

    // Accepts either
    // {name: string, image: string, price?: number, description?: string}
    // or
    // {title: string, imageUrl: string, price?: number, description?: string}
    product: {
      type:     Object,
      required: true,
    },
  },
})
export default class ProductCard extends Vue {
  get name() {
    const { name, title } = this.product;

    return name || title || '';
  }

  get imageUrl() {
    const { image, imageUrl } = this.product;

    return helpers.getImagePath(image || imageUrl || '');
  }

  /**
   * Get product price
   * @param price
   * @returns {number}
   */
  getFormattedProductPrice(price) {
    return price.toFixed(2);
  }

  /**
   * Define product is valid to show product card or not.
   * Product is valid if it exists and contains not only image.
   * @param product Product.
   * @returns {boolean} Whether the product is valid or not.
   */
  isValidProduct(product) {
    const isExists = product != null;
    const hasImage = product?.image || product?.imageUrl;
    const propertiesCount = isExists ? Object.keys(product).length : 0;
    const fitWithImage = isExists && hasImage && propertiesCount > 1;
    const fitWithoutImage = isExists && !hasImage && propertiesCount > 0;

    return fitWithImage || fitWithoutImage;
  }
}
</script>

<style lang="scss" module="$product">
@import "~@/style/variables.scss";

.product {
  cursor: pointer;
  border: 1px solid $product-border-color;
  border-radius: 8px;
  padding: 15px;
}

.name {
  font-family: 'Gotham', sans-serif;
  font-size: 15px;
  line-height: 20px;
  font-weight: 700;
  color: $black;
  text-align: center;
  padding: 0 10px;
  text-transform: capitalize;
}

.price {
  font-family: 'Gotham', sans-serif;
  font-size: 15px;
  line-height: 20px;
  font-weight: 700;
  color: $black;
  text-align: center;
  padding: 0 10px;
}

.description {
  font-size: 12px;
  text-align: center;
  margin-top: 0.5rem;
}

.image {
  width: auto;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
  max-width: 60%;
}

@media screen
  and (min-width: $mobile-breakpoint-max + 1)
  and (max-width: $kiosk-breakpoint-max) {
  .name {
    font-size: 40px;
    line-height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/shared/components/ProductCard.vue